import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

import { LocationComponent } from './location.component';
import { LocationIndexComponent } from './location/location-index.component';
import { LocationSaleDetailsComponent } from './location-sale-details/location-sale-details.component';


const locationRoutes: Routes = [
    {
        path: 'locations',
        component: LocationComponent,
        children: [
            {
                path: '',
                component: LocationIndexComponent,
            },
            {
                path: 'detail/:id',
                component: LocationSaleDetailsComponent
            }
        ]
    }

];

export const locationRouting: ModuleWithProviders = RouterModule.forChild(locationRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/location.routing.ts